import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from '@shared/guards/is-authenticated.guard';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { OrganizationRouteNames, RouteNames } from './route-names';
import { MainPageComponent } from './core/pages/main-page/main-page.component';
import { UserLoginComponent } from './modules/user/pages/user-login/user-login.component';
import { UserRegisterComponent } from './modules/user/pages/user-register/user-register.component';
import { UserResetPasswordComponent } from './modules/user/pages/user-reset-password/user-reset-password.component';
import { HomeComponent } from './modules/home/home/home.component';
import { ForbiddenPageComponent } from './core/pages/forbidden-page/forbidden-page.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: RouteNames.MAIN_PAGE,
        component: MainPageComponent,
        title: 'route.name.main',
      },
      {
        path: RouteNames.LOGIN_PAGE,
        component: UserLoginComponent,
        title: 'route.name.signIn',
      },
      {
        path: RouteNames.REGISTER_PAGE,
        component: UserRegisterComponent,
        title: 'route.name.registration',
      },
      {
        path: RouteNames.RESET_PASSWORD_PAGE,
        component: UserResetPasswordComponent,
        title: 'route.name.resetPassword',
      },
      {
        path: RouteNames.HOME,
        title: 'route.name.home',
        canActivate: [isAuthenticatedGuard],
        component: HomeComponent,
      },
      {
        path: RouteNames.USER,
        title: 'route.name.user',
        loadComponent: () =>
          import('./modules/user/pages/user-edit/user-edit.component').then(
            c => c.UserEditComponent,
          ),
        canActivate: [isAuthenticatedGuard],
      },
      {
        path: OrganizationRouteNames.MAIN,
        title: 'route.name.company',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/organization/routes').then(
            mod => mod.ORGANIZATION_ROUTES,
          ),
      },
      {
        path: RouteNames.ADMIN,
        title: '',
        canActivate: [isAuthenticatedGuard],
        loadChildren: () =>
          import('./modules/admin/routes').then(mod => mod.ADMIN_ROUTES),
      },
      {
        path: RouteNames.FORBIDDEN_PAGE,
        title: 'system.httpStatus.forbidden',
        component: ForbiddenPageComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: RouteNames.HOME,
  },
];
